import { render, staticRenderFns } from "./ReferPatientForm.vue?vue&type=template&id=3cf519fc&scoped=true"
import script from "./ReferPatientForm.vue?vue&type=script&lang=js"
export * from "./ReferPatientForm.vue?vue&type=script&lang=js"
import style0 from "./ReferPatientForm.vue?vue&type=style&index=0&id=3cf519fc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cf519fc",
  null
  
)

export default component.exports